import {
    Container,
    Row,
    Col
} from "reactstrap";
import {
    ABOUT_IMPACT_GOALS,
    OEC_MAIN_PARTNERS,
} from "./utils";
import {GradientImageOverlay} from "./Shared";
import {getPlayStoreUrl} from "../../utils";


export const AboutHero = () => {
    return (
        <section
            className="py-lg-8 py-5 d-flex align-items-center justify-content-center position-relative"
            style={{minHeight: "80vh"}}
            aria-labelledby="hero-title"
        >
            <GradientImageOverlay imagePath={"/public/adra_images/adra_image_2.webp"} />

            <Container className={"hero-container-padding"}  style={{zIndex: 2}}>
                <Row className="justify-content-center">
                    <Col lg="10" xl="9" className="text-center">
                        <div className="px-3">
                            {/* Main Title */}
                            <h1
                                id="hero-title"
                                className="hero-responsive-title text-white mb-4"
                                style={{textShadow: "0 2px 4px rgba(0,0,0,0.5)"}}
                            >
                                Connecting skilled
                                <span className="text-warning"> Solar PV Technicians</span> with
                                energy job opportunities
                            </h1>

                            {/* Subtitle */}
                            <h2
                                className="h4 text-white font-weight-light"
                                style={{opacity: 0.9, textShadow: "0 2px 4px rgba(0,0,0,0.5)"}}
                            >
                                In Partnership With <strong>ADRA Ethiopia</strong> & <strong>On Energy Consult</strong>
                            </h2>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};


export const Impact = () => {


    return (
        <section
            id="impact"
            className="relative d-flex flex-column justify-content-end py-7 py-lg-9"
            style={{
                backgroundImage: 'url("/public/impact%20background.webp")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
                minHeight: '450px',
                color: 'white'
            }}
            aria-labelledby="impact-goals"
        >
            <Container className="position-relative zindex-100">
                <Row>
                    <Col lg="8">
                        <div className="mb-4">
                            <h2 id="impact-goals" className="display-3 text-white font-weight-bold mb-3">
                                Impact Goals
                            </h2>

                            {/* Goals List (Pills) */}
                            <div className="d-flex flex-wrap align-items-center mb-4">
                                {ABOUT_IMPACT_GOALS.map((goal) => (
                                    <span
                                        key={goal}
                                        className="badge badge-pill badge-outline-white mr-2 mb-2 px-4 py-2"
                                        style={{
                                            border: '1px solid white',
                                            fontSize: '0.875rem',
                                            textTransform: 'none',
                                            fontWeight: '400'
                                        }}
                                    >
                                        {goal}
                                    </span>
                                ))}
                            </div>

                            {/* Description */}
                            <p className="text-white opacity-9">
                                Hundreds of trained{" "}
                                <abbr
                                    title="Solar Photovoltaic (PV) Technicians"
                                    className="font-weight-600"
                                    style={{textDecoration: 'underline dotted'}}
                                >
                                    Solar PV Technicians
                                </abbr>{" "}
                                remain underutilized. On Energy Connect App is here to change that by
                                connecting talent with opportunity and powering communities with clean
                                energy.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export const PlatformPreview = () => {
    return (
        <section
            className="py-7 border border-top-0 border-primary rounded"
            aria-labelledby="platform-preview"
            id="platform"
        >
            <Container>
                <Row className="align-items-center">
                    {/* Left Side: App Preview Image */}
                    <Col lg="6" className="mb-4 mb-lg-0">
                        <div className="position-relative">
                            <img
                                src="/public/platform preview 4x.webp"
                                alt="Preview of the On Energy Connect mobile app"
                                className="img-fluid rounded"
                                decoding="async"
                                loading="lazy"
                                width={1976}
                                height={1580}
                            />
                        </div>
                    </Col>

                    {/* Right Side: Content */}
                    <Col lg="6">
                        <div className="pl-lg-4">
                            <h2 id="platform-preview" className="display-3 text-warning font-weight-bold mb-3">
                                Platform Preview
                            </h2>
                            <p className="leading-relaxed text-dark mb-4">
                                The On Energy Connect
                                platform will
                                offer an intuitive interface where technicians can build profiles, highlight
                                certifications, and
                                apply for jobs directly. Recruiters, energy organizations and companies will be able to
                                post
                                openings, filter candidates, and track applications seamlessly.
                            </p>

                            {/* Contact Link */}
                            <a
                                href={getPlayStoreUrl()}
                                className="d-flex align-items-center text-decoration-none group"
                            >
                                <img
                                    src="/public/icons/playstore.svg"
                                    className="mr-2"
                                    style={{height: "2rem", objectFit: "contain"}}
                                    alt="Form"
                                />
                                <p className="mb-0 text-dark font-weight-600 border-bottom border-warning">
                                    Download the mobile app, and connect with jobs in the energy sector.
                                </p>
                            </a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};


export const Partnerships = () => {

    return (
        <section
            id="about"
            className="py-7 border border-primary rounded"
            aria-labelledby="partnership-title"
        >
            <Container>
                <Row className="justify-content-center text-left text-md-center">
                    <Col lg="10">
                        {/* Heading */}
                        <h2 id="partnership-title" className="display-3 text-primary font-weight-bold mb-3">
                            Powered by Partnership
                        </h2>

                        {/* Description */}
                        <div className="row justify-content-center">
                            <Col xl="10">
                                <p className="mb-5 leading-relaxed text-dark">
                                    On Energy Connect is a partnership product of <strong>ADRA Ethiopia</strong> and
                                    <strong> On Energy Consult</strong>, designed to link skilled{" "}
                                    <abbr title="Solar Photovoltaic (PV) Technicians"
                                          className="text-primary font-weight-600">
                                        Solar PV Technicians
                                    </abbr>{" "}
                                    with meaningful energy job opportunities across Ethiopia. Together,
                                    we’re building a future where every technician is visible, and every
                                    community is empowered. Built both as a web and mobile solution, it
                                    streamlines the way technicians discover work and enables
                                    organizations to find qualified talent quickly and reliably.
                                </p>
                            </Col>
                        </div>

                        {/* Logos Wrapper */}
                        <div className="d-flex flex-wrap justify-content-center align-items-center">
                            {OEC_MAIN_PARTNERS.map((partner) => (
                                <a
                                    key={partner.name}
                                    href={partner.website}
                                    className="mx-4 my-3 partner-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{transition: 'transform 0.2s ease-in-out'}}
                                >
                                    <img
                                        src={partner.logo}
                                        style={partner.imgStyle}
                                        alt={`${partner.name} organization logo`}
                                    />
                                </a>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};